import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setBusinessTerms, setLogin } from "state";
import { baseURL } from "services/API";

const useLandlordOtpLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchLandlordDetails = async (landlordId, token) => {
    const response = await fetch(`${baseURL}/landlords/details/${landlordId}`, {
      method: "GET",
      headers: { authorization: `Bearer ${token}` },
    });
    return response.json();
  };

  const requestOtp = async (phoneNumber) => {
    const response = await fetch(`${baseURL}/accounts/authenticate/landlord-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ phone_number: phoneNumber }),
    });
    return response.json();
  };

  const verifyOtp = async ({ relatedUser, otpCode }) => {
    const response = await fetch(`${baseURL}/accounts/otp/verify-landlord`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        related_user: relatedUser,
        otp_code: otpCode,
      }),
    });
    return response.json();
  };

  const completeLogin = async (verificationData) => {
    const token = verificationData?.token?.token;
    const landlordPayload = verificationData?.landlord;
    const landlordId =
      typeof landlordPayload === "object" ? landlordPayload?.id : landlordPayload;

    let landlordDetails = verificationData?.landlord_details || null;

    if (landlordId && token) {
      try {
        const landlordData = await fetchLandlordDetails(landlordId, token);
        dispatch(setBusinessTerms(landlordData?.business_terms || {}));
        landlordDetails = landlordData?.data || landlordData;
      } catch (detailsError) {
        dispatch(setBusinessTerms({}));
      }
    }

    const einvoicingEnabled = Boolean(
      verificationData?.einvoicing_enabled ??
        verificationData?.landlord_details?.einvoicing_enabled ??
        landlordDetails?.einvoicing_enabled ??
        landlordPayload?.einvoicing_enabled
    );

    dispatch(
      setLogin({
        user: verificationData?.user_details,
        token,
        landlord: landlordId,
        landlordDetails,
        einvoicingEnabled,
      })
    );

    if (landlordDetails?.verified_status) {
      navigate("/home");
      return;
    }

    navigate("/settings", { state: { showVerificationAlert: true } });
  };

  return {
    requestOtp,
    verifyOtp,
    completeLogin,
  };
};

export default useLandlordOtpLogin;
